// extracted by mini-css-extract-plugin
export default {"toggler":"toggler_toggler__5MTLO","label":"toggler_label__q3B9c"};